<script setup>
import { ref, computed, onMounted, useTemplateRef, watch, provide } from 'vue'
import _ from 'lodash'
import { useStore } from 'vuex'
import ModalBox from './ModalBox.vue'
import StreamsWidget from '../ui/StreamsWidget.vue'
import FormButton from '../Atoms/FormButton.vue'
import { useMatchMedia } from '@/utils'

const store = useStore()

//Emits
const emit = defineEmits({
	'add-stream': () => true
})

// TemplateRefs
const streamsWidget = useTemplateRef('streamsWidget')

// CONST
const isDesktop = useMatchMedia('(min-width: 768px)')

// Models
const isVisible = defineModel('isVisible')


// Computed
const vodStreams = computed(() => store.getters['Streams/vodStreams'])
const allInOneStreams = computed(() => store.getters['Streams/allInOneStreams'])


const selectedStream = ref(null)

const isDisabled = computed(() => !selectedStream.value)



// Hooks
onMounted(async () => {
	if (vodStreams.value.length === 0 || allInOneStreams.value.length === 0) {
		await store.dispatch('Streams/getStreams')
	}
})

// Methods
const saveChanges = () => {
	emit('add-stream', selectedStream.value)
	isVisible.value = false
}

const selectSource = (stream) => {
	selectedStream.value = stream
}

watch(isVisible, (visible) => {
	if (!isDesktop.value && streamsWidget.value) {
		if (visible) {
			streamsWidget.value.openView()
		} else {
			streamsWidget.value.closeView({ emitEvent: false })
		}
	}
})
</script>

<template>
	<StreamsWidget
		ref="streamsWidget"
		v-if="!isDesktop"
		placement="body"
		source="dynamic"
		hide-notification
		@add-stream="selectSource"
		@close="isVisible = false"
		header-title="Select video source"
		:show-plus-button="false"
		tab-size="1/2"
		variant="modern"
	>
		<template #footer>
			<div class="flex flex-col gap-2 !my-3">
				<FormButton class="justify-center" full-width label="Close" type="secondary" @click="isVisible = false" />
				<FormButton class="justify-center" full-width label="Confirm" @click="saveChanges" :disabled="isDisabled" />
			</div>
		</template>
	</StreamsWidget>
	<ModalBox v-else v-model="isVisible" size="lg" title="Select video source" wrapper-classes="lg:max-w-lg lg:max-h-[80vh] overflow-y-auto [scrollbar-gutter:stable]">
		<div class="px-6 pb-4">
			<StreamsWidget v-if="isDesktop" placement="body" source="dynamic" variant="modern" 
				@add-stream="selectSource" tab-size="1/2" />
		</div>
		<template #footer>
			<div class="px-6 py-4 flex items-center justify-end gap-x-2 border-t border-surface-3">
				<FormButton label="Close" type="secondary" @click="isVisible = false" />
				<FormButton label="Confirm" @click="saveChanges" :disabled="isDisabled" />
			</div>
		</template>
	</ModalBox>
</template>

<style></style>
